import i18n from '@/i18n';
import { Favorite, Module as NxtModule } from '@nxtpeople/nxt-vue-library';
import { Module } from 'vuex';
import { FavoriteService } from './favorite.service';
const service = new FavoriteService();

export interface FavoriteState {}

const FavoriteStore: Module<FavoriteState, any> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async postFavorite(context, body: Favorite) {
         try {
            const response = await service.postFavorite(body);
            context.rootState.userInfo.userInfo.favorites.push(response);
            context.rootState.userInfo.userInfo.modules.forEach((module: NxtModule) => {
               if (module.id == response.module_id) {
                  module.favorites = module.favorites ? [...module.favorites, response] : [response];
               }
            });
            context.dispatch(
               'addNotification',
               {
                  notification: {
                     type: 'info',
                     title: i18n.global.t('added_favorite'),
                  },
               },
               { root: true }
            );
            return response;
         } catch (error) {
            throw error;
         }
      },

      async deleteFavorite(context, favoriteId: number) {
         try {
            const response = await service.deleteFavorite(favoriteId);
            context.rootState.userInfo.userInfo.favorites = context.rootState.userInfo.userInfo.favorites.filter(
               (favorite: Favorite) => favorite.id != favoriteId
            );
            context.rootState.userInfo.userInfo.modules.forEach((module: NxtModule) => {
               module.favorites = (module.favorites as Array<Favorite>)?.filter((favorite: Favorite) => favorite.id != favoriteId);
            });
            context.dispatch(
               'addNotification',
               {
                  notification: {
                     type: 'info',
                     title: i18n.global.t('deleted_favorite'),
                  },
               },
               { root: true }
            );
            return response;
         } catch (error) {
            throw error;
         }
      },
   },
};

export default FavoriteStore;
